
import { defineComponent, toRaw } from "vue"

interface CardLg {
  count: number
  title: string
  text?: string
}

interface CardSm {
  count: string
  text: string
}

export default defineComponent({
  data: () => ({
    cardsLg: toRaw([
      {
        count: 20,
        title: "субъектов РФ",
      },
      {
        count: 342338,
        title: "участников <br> по&nbsp;всей России",
      },
      {
        count: 50,
        title: "форматов мероприятий",
        text: "форумы, конференции, выставки, стратегические сессии, мастер-классы, семинары, лекции, онлайн-курсы",
      },
      {
        count: 32,
        title: "научно-популярных <br> мероприятия",
      },
      {
        count: 5000,
        title: "участников <br> обучающих очных и&nbsp;онлайн-мероприятий",
      },
      {
        count: 120,
        title: "изобретений <br> и&nbsp;технологий",
        text: "представлены на&nbsp;различных выставках в&nbsp;рамках Фестиваля",
      },
    ] as CardLg[]),

    cardsSm: toRaw([
      {
        count: "62",
        text: "видеоролика об&nbsp;изобретениях и&nbsp;изобретателях",
      },
      {
        count: "4700",
        text: "публикаций в&nbsp;СМИ и&nbsp;соцсетях о&nbsp;Фестивале ВОИР",
      },
      {
        count: "6,6 млн",
        text: "просмотров в&nbsp;соцсетях",
      },
      {
        count: "31,6 млн",
        text: "охват СМИ",
      },
      {
        count: "28,7 млн",
        text: "аудитория в&nbsp;соцсетях",
      },
      {
        count: "45,1 тыс",
        text: "вовлеченность в&nbsp;соцсетях (перепосты, комментарии, лайки)",
      },
    ] as CardSm[]),
  }),
})
